class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    // 新增：hover 延迟关闭定时器（避免快速划过触发）
    this.hoverTimer = null;
    // 移除原有的 focusout/toggle 事件，绑定 hover 事件
    this.bindHoverEvents();
  }

  // 新增：绑定 hover 事件（核心改造点）
  bindHoverEvents() {
    // 鼠标进入组件 → 展开面板
    this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    // 鼠标离开组件 → 延迟关闭面板
    this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
    // 给 details 本身也绑定 hover（兼容子元素hover）
    this.mainDetailsToggle.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener("mouseleave", this.onMouseLeave.bind(this));
  }

  // 鼠标进入 → 展开面板
  onMouseEnter() {
    // 清除延迟关闭定时器
    clearTimeout(this.hoverTimer);
    // 标记为展开状态
    this.mainDetailsToggle.setAttribute("open", "true");
    // 更新无障碍属性
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", true);
    // 播放动画（复用原有逻辑）
    this.handleAnimation(true);
    // 触发自定义 toggle 逻辑（供子类扩展）
    this.onToggle();
  }

  // 鼠标离开 → 延迟关闭面板（优化体验）
  onMouseLeave() {
    // 300ms 延迟关闭，避免快速划过触发
    this.hoverTimer = setTimeout(() => {
      this.close();
      // 取消动画（复用原有逻辑）
      this.handleAnimation(false);
      // 触发自定义 toggle 逻辑
      this.onToggle();
    }, 300);
  }

  // 重构：统一处理动画播放/取消
  handleAnimation(isOpen) {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (isOpen) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  // 移除原有 onFocusOut（hover 逻辑替代）
  // 重构 onToggle：从事件触发改为手动调用
  onToggle() {
    // 空方法，供子类重写
  }

  // 保留原有 close 方法（更新无障碍属性）
  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
  }

  // 组件销毁时清除定时器（避免内存泄漏）
  disconnectedCallback() {
    clearTimeout(this.hoverTimer);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  // 重写 onToggle 方法（保留原有 header 逻辑）
  onToggle() {
    if (!this.header) return;
    // 根据面板是否展开设置 preventHide 状态
    this.header.preventHide = this.mainDetailsToggle.hasAttribute("open");

    // 仅初始化一次 CSS 变量
    if (document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") !== "")
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define("header-menu", HeaderMenu);
